__turbopack_context__.v({
  "add-comment": "style-module-scss-module__jVj77W__add-comment",
  "component": "style-module-scss-module__jVj77W__component",
  "form-error": "style-module-scss-module__jVj77W__form-error",
  "icons": "style-module-scss-module__jVj77W__icons",
  "modal": "style-module-scss-module__jVj77W__modal",
  "note": "style-module-scss-module__jVj77W__note",
});
